export default "__VITE_ASSET__P0lGfq6g__"